// extracted by mini-css-extract-plugin
export default {"description":"tab-legal_description__QEESr","descriptionSecondary":"tab-legal_descriptionSecondary__Z9RJp","checkboxRow":"tab-legal_checkboxRow__cTq46"};